import React, { useState, useContext, useEffect, useCallback, Dispatch, SetStateAction } from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { LineItem } from 'shared/types/cart';
import { PersonalizeOptions, WarrantyOptions } from 'shared/types/cart/Cart';
import { Variant } from 'shared/types/product';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { getCookie } from 'typescript-cookie';
import Notification from '@/components/customercenter-ui/common/notification/notification';
import { Label } from '@/components/customercenter-ui/components/ui/customLabel/customLabel';
import { RadioGroup, RadioGroupItem } from '@/components/customercenter-ui/components/ui/customRadio/customRadio';
import { Textarea } from '@/components/customercenter-ui/components/ui/textarea';
import ErrorIcon from '@/components/customercenter-ui/svgs/notifications/error';
import {
  isFutureDate,
  daysBetweenCurrentAndDate,
  getArrivalAndBackorderDateFromResponse,
} from '@/components/customercenter-ui/utils/fedexUtils';
import { useAddToCart } from '@/context/addToCartProvider';
import WarningIcon from '@/customercenter-ui/svgs/notifications/warning';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { CurrencyHelpers } from '@/helpers/utils/currencyHelpers';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { routerUrl } from '@/helpers/utils/routerUrl';
import {
  combinedKeyPressHandler,
  getFormattedBrandSiteName,
  getSelectedDivision,
  getAgentName,
} from '@/helpers/utils/siteUtils';
import { useCart, useProduct } from 'frontastic';
import { AvailabilityMsgDisplay } from './availabilityMsg';
import ExcludedBrandsNote from './excludedBrandsNote';
import { Price } from './price';
import {
  COOKIE_KEYS,
  VARIANT_SELECTOR_VALUE_1,
  VARIANT_SELECTOR_VALUE_2,
  VARIANT_SELECTOR_VALUE_3,
  IS_PERSONALIZED,
  RECENTLY_REMOVED,
  ORDER_TYPES,
  ADDITIONAL_DETAILS_NAME,
  ADDITIONAL_DETAILS_TYPE,
  FULFILLMENT_METHOD,
} from '../../../../../../../constants/constant';
import { sortNotesByTimestamp } from '../../../../../../customercenter-ui/components/cart/utils';
import ShoppingBag from '../../../../../../customercenter-ui/components/icons/shoppingBag';
import { PdpProtectionPlan } from '../../../../../../customercenter-ui/components/product/details/components/pdpProtectionPlan';
import SizeChart from '../../../../../../customercenter-ui/components/product/details/components/SizeChart';
import {
  getAttribute,
  getFilteredAttribute,
} from '../../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';
import Counter from '../../../../../../customercenter-ui/components/quantityAddSub/counter';
import { Button } from '../../../../../../customercenter-ui/components/ui/button';
import ToolTips from '../../../../../../customercenter-ui/tooltip';
import ContentStackImage from '../../../../../common/contentStackImage/contentStackImage';
import { ProductContext } from '../../contexts';
import CustomToolTips from '../../helpers/utils/colorToolTip';
import { sizeButton } from '../../helpers/utils/sizeButton';
import PdpTooltip from '../PdpTooltip';
interface Props {
  showPDPBottomBox?: boolean;
  isEditCart?: boolean;
  toggle?: () => void;
  drawerFlag?: boolean;
  setOpenModal?: Dispatch<SetStateAction<boolean>>;
  lineItem?: LineItem;
  selectedWarranty?: any;
  setEditNotificationMessage?: any;
  setShowUndoButton?: (value: boolean) => void;
  setNotificationMessage: (message: string) => void;
  setIsError: (isError: boolean) => void;
  setSeeSimilarItems?: any;
  setArrivalDateForEditCart?: any;
  setIsDateCheckedInEditCart?: (value: boolean) => void;
  setCartHeaderQty?: (value: number) => void;
}

let initialColorLoaded = false;
let filtersAttrSelected = false;
const PdpColorFilter: React.FC<Props> = ({
  showPDPBottomBox = true,
  toggle,
  setEditNotificationMessage,
  setShowUndoButton,
  setIsError,
  setNotificationMessage,
  setSeeSimilarItems,
  setCartHeaderQty,
}) => {
  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const router = useRouter();
  const {
    widgetData,
    initialColor,
    setInitialColor,
    productData,
    initialSize,
    setInitialSize,
    setGlobalAddToCart,
    setGlobalSizeAndWidthGroup,
    isMailOrderProduct,
    webAccountId,
    setGlobalPersonalize,
    initialArrivalDate,
  } = useContext(ProductContext);
  const [notesError, setNotesError] = useState('');
  const [agentName] = useState(getAgentName().replace(/@.*/, ''));
  const [mailOrderNote, setMailOrderNote] = useState('');
  const { addItem, data: cartData, replaceCartLineItem, updateItem, removeItem } = useCart(false);
  const {
    error,
    setError,
    setDrawerVisible,
    setSuccessMsg,
    setErrorMsg,
    sizeErrorMessage,
    setSizeErrorMessage,
    widthErrorMessage,
    setWidthErrorMessage,
    availabilityMessage,
    setAvailabilityMessage,
    setItemUpdated,
  } = useAddToCart();
  const [qty, setQty] = useState(1);
  const { getAvailability } = useProduct();
  const [lineItem, setLineItem] = useState<LineItem>();
  const [selectedWarranty, setSelectedWarranty] = useState<LineItem>();
  const [retryCount, setRetryCount] = useState(0);
  const locale = 'en';
  const projectSettings: ProjectSettings = useProjSettings();
  const maxRetries = 3;
  const initialDesignId = lineItem?.personalizeProductId ?? '';
  const personalizeUserId = lineItem?.personalizeUserId ?? '';
  const [selectedSize, setSelectedSize] = useState<string>();
  const [selectedWidth, setSelectedWidth] = useState<string>();
  const [sizeGroup, setSizeGroup] = useState<Map<string, boolean>>();
  const [widthGroup, setWidthGroup] = useState<Map<string, boolean>>();
  const [availabilityClassName, setAvailabilityClassName] = useState('text-forestGreen');
  const [backOrderedValue, setBackOrderedValue] = useState(0);
  const [selectedWarrantySku, setSelectedWarrantySku] = useState('');
  const [maxQuantityWarningMessage, setMaxQuantityWarningMessage] = useState('');
  const [isAvailableMsgDisplay, setIsAvailableMsgDisplay] = useState(false);
  const [artifiLoaded, setArtifiLoaded] = useState(false);
  const params = useSearchParams();
  const isEditCart = params?.get('updateItem') ? true : false;
  const query = useSearchParams();
  function getLineItemIdFromCurrentUrl() {
    const fullUrl = document.URL;
    const url = new URL(fullUrl);
    return url.searchParams.get('lineItemId');
  }

  const URLLineItemId = getLineItemIdFromCurrentUrl();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isProcessing, setIsProcessing] = useState(false);
  const loggedIn = false;
  const [isInStockWithBackOrder, setIsInStockWithBackOrder] = useState(false);
  const [backOrderedArrivalDate, setBackOrderedArrivalDate] = useState('');
  const [stockValue, setStockValue] = useState<number>();
  const [arrivalDate, setArrivalDate] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDeliveryCodeUpdated, setIsDeliveryCodeUpdated] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [moreVariants, setMoreVariants] = useState<boolean>();
  let notesPayload: any;
  if (mailOrderNote) {
    const notes = cartData?.additionalDetails?.notes?.notes ?? [];
    const reasons = cartData?.additionalDetails?.notes?.reasons ?? [];
    const sortedNotes = sortNotesByTimestamp([...notes, ...reasons]);
    const notesTableData: any = sortedNotes;
    notesPayload = {
      name: `${ADDITIONAL_DETAILS_NAME.ADD_NOTE}-${notesTableData?.length ?? 0}`,
      value: mailOrderNote,
      type: ADDITIONAL_DETAILS_TYPE.NOTES,
      agentName,
    };
  }

  useEffect(() => {
    if (initialDesignId) {
      setIsProcessing(true);
    }
    if (initialSize && initialDesignId && webAccountId) {
      openPersonalizationUI();
    }
  }, [initialSize, webAccountId]);

  useEffect(() => {
    const isPersonalized = sessionStorage.getItem(IS_PERSONALIZED) || '';
    if (initialSize && isPersonalized && webAccountId) {
      openPersonalizationUI();
      sessionStorage.setItem(IS_PERSONALIZED, JSON.stringify(false));
    }
  }, [initialSize, webAccountId]);

  const pathname = usePathname();
  const productKeyFromQuery = params?.get('q')?.split('-').slice(0, 2).join('-');

  const valueToClassName: any = {
    onlyLeft: 'text-scarletRed',
    backOrdered: 'text-[#1F3A65]',
    inStock: 'text-forestGreen',
    outOfStock: 'text-scarletRed',
  };

  const checkIsAvailMsgReq = () => {
    let isCheckRequired = false;
    if (sizeGroup && widthGroup) {
      if (sizeGroup?.size > 0 && widthGroup?.size > 0 && selectedSize && selectedWidth) {
        isCheckRequired = true;
      } else if (sizeGroup?.size > 0 && widthGroup?.size === 0 && selectedSize) {
        if (sizeGroup?.size === 1 && selectedSize === 'No Size') {
          isCheckRequired = true;
        } else if (selectedSize) {
          isCheckRequired = true;
        }
      }
    } else {
      if (selectedSize || selectedWidth) {
        isCheckRequired = true;
      }
    }
    return isCheckRequired;
  };

  const isWidthAvailable = (width: string) => {
    const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
    let isAvailable = false;
    const sizeName = getFilteredAttribute('variantSelectorValue2', initialColor?.masterVariant);
    const widthName = getFilteredAttribute('variantSelectorValue3', initialColor?.masterVariant);
    if ((!selectedSize || (selectedSize && sizeName === selectedSize)) && widthName === width) {
      isAvailable = true;
    }
    initialColor?.variants?.forEach((variant: any) => {
      const sizeName = getFilteredAttribute('variantSelectorValue2', variant);
      const widthName = getFilteredAttribute('variantSelectorValue3', variant);
      if ((!selectedSize || (selectedSize && sizeName === selectedSize)) && widthName === width) {
        isAvailable = true;
      }
    });
    if (isAvailable) {
      if (selectedSize) {
        const value = widthGroup?.get(width);
        isAvailable = value ?? false;
      } else {
        const sizeVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue3', width);
        if (sizeVariant?.length > 0) {
          isAvailable = sizeVariant?.some(
            (sizeVariantItem: Variant) =>
              sizeVariantItem?.availability?.noChannel?.isOnStock ||
              sizeVariantItem?.backOrder ||
              cartData?.orderType == ORDER_TYPES.MAIL_ORDER,
          );
        } else {
          isAvailable = false;
        }
      }
    }
    return isAvailable;
  };

  const getVariantsForSizeAndWidhtvalue = (
    allVariants: Variant[],
    sizePropertyName: string,
    sizePropertyValue: string,
    widthPropertyName: string,
    widthPropertyValue: string,
  ): Variant[] => {
    const filteredVariants = allVariants?.filter((variant) =>
      variant?.attributesRaw?.some((attr: any) => attr?.name === sizePropertyName && attr?.value === sizePropertyValue),
    );

    const sizeAndWidthVariant = filteredVariants?.filter((variant) =>
      variant?.attributesRaw?.some(
        (attr: any) => attr?.name === widthPropertyName && attr?.value === widthPropertyValue,
      ),
    );
    return sizeAndWidthVariant;
  };

  const isSizeAvailable = (size: string) => {
    const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
    let isAvailable = false;
    const sizeName = getFilteredAttribute('variantSelectorValue2', initialColor?.masterVariant);
    const widthName = getFilteredAttribute('variantSelectorValue3', initialColor?.masterVariant);
    if ((!selectedWidth || (selectedWidth && widthName === selectedWidth)) && sizeName === size) {
      isAvailable = true;
    }
    initialColor?.variants?.forEach((variant: any) => {
      const sizeName = getFilteredAttribute('variantSelectorValue2', variant);
      const widthName = getFilteredAttribute('variantSelectorValue3', variant);
      if ((!selectedWidth || (selectedWidth && widthName === selectedWidth)) && sizeName === size) {
        isAvailable = true;
      }
    });
    if (isAvailable) {
      if (widthGroup?.size !== 0) {
        if (selectedSize && selectedSize === size) {
          const value = sizeGroup?.get(size);
          if (selectedWidth && value) {
            const sizeWidthVariant: Variant[] = getVariantsForSizeAndWidhtvalue(
              allVariants,
              'variantSelectorValue2',
              size,
              'variantSelectorValue3',
              selectedWidth,
            );
            isAvailable =
              (sizeWidthVariant?.[0].availability?.noChannel?.isOnStock ||
                sizeWidthVariant?.[0]?.backOrder ||
                cartData?.orderType == ORDER_TYPES.MAIL_ORDER) ??
              false;
          } else {
            const variantForSize: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue2', size);
            isAvailable = variantForSize?.some(
              (variantForSizeItem: Variant) =>
                variantForSizeItem?.availability?.noChannel?.isOnStock ||
                variantForSizeItem?.backOrder ||
                cartData?.orderType == ORDER_TYPES.MAIL_ORDER,
            );
          }
        } else {
          const widthVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue2', size);
          if (widthVariant?.length > 0) {
            if (selectedWidth) {
              const selectedWidthVariantFrSize: Variant[] = getVariantsForAttributeValue(
                widthVariant,
                'variantSelectorValue3',
                selectedWidth,
              );
              if (selectedWidthVariantFrSize?.length === 1) {
                isAvailable =
                  (selectedWidthVariantFrSize?.[0].availability?.noChannel?.isOnStock ||
                    selectedWidthVariantFrSize?.[0]?.backOrder ||
                    cartData?.orderType == ORDER_TYPES.MAIL_ORDER) ??
                  false;
              } else {
                isAvailable = selectedWidthVariantFrSize?.some(
                  (wdthSizeItem: Variant) =>
                    wdthSizeItem?.availability?.noChannel?.isOnStock ||
                    wdthSizeItem?.backOrder ||
                    cartData?.orderType == ORDER_TYPES.MAIL_ORDER,
                );
              }
            } else {
              isAvailable = widthVariant?.some(
                (widthVariantItem: Variant) =>
                  widthVariantItem?.availability?.noChannel?.isOnStock ||
                  widthVariantItem?.backOrder ||
                  cartData?.orderType == ORDER_TYPES.MAIL_ORDER,
              );
            }
          } else {
            isAvailable = false;
          }
        }
      } else {
        const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
        const filteredVariants = allVariants?.filter((variant) =>
          variant?.attributesRaw?.some((attr: any) => attr?.name === 'variantSelectorValue2' && attr?.value === size),
        );
        isAvailable =
          (filteredVariants?.[0]?.availability?.noChannel?.isOnStock ||
            filteredVariants?.[0]?.backOrder ||
            cartData?.orderType == ORDER_TYPES.MAIL_ORDER) ??
          false;
      }
    }
    return isAvailable;
  };

  const getVariantsForAttributeValue = (
    allVariants: Variant[],
    propertyName: string,
    propertyValue: string,
  ): Variant[] => {
    const filteredVariants = allVariants?.filter((variant) =>
      variant?.attributesRaw?.some((attr: any) => attr?.name === propertyName && attr?.value === propertyValue),
    );
    return filteredVariants;
  };

  useEffect(() => {
    if (initialSize && sizeGroup?.size) {
      if (!isEditCart) {
        if (sizeGroup?.size === 1) {
          const firstEntry = sizeGroup.entries().next().value;
          setSelectedSize(firstEntry?.[0] || '');
        }
      }
    }
  }, [initialSize, sizeGroup]);

  useEffect(() => {
    if (initialColor) {
      setInitialSize(initialColor.masterVariant);
      initialColor?.variants?.map((obj: any) => {
        if (obj.key === lineItem?.variant?.sku) {
          setSelectedSize(getFilteredAttribute(VARIANT_SELECTOR_VALUE_2, obj));
          setSelectedWidth(getFilteredAttribute(VARIANT_SELECTOR_VALUE_3, obj));
        }
      });
      if (initialColor?.masterVariant?.sku === lineItem?.variant?.sku) {
        setSelectedSize(getFilteredAttribute(VARIANT_SELECTOR_VALUE_2, initialColor?.masterVariant));
        setSelectedWidth(getFilteredAttribute(VARIANT_SELECTOR_VALUE_3, initialColor?.masterVariant));
      }

      if (!isEditCart) {
        setSelectedSize('');
        if (widthGroup?.size !== 1) {
          setSelectedWidth('');
        }
      }
    }
  }, [initialColor]);

  useEffect(() => {
    if (initialSize && !sizeGroup) {
      const sizeGroup: Map<string, boolean> = new Map();
      const widthGroup: Map<string, boolean> = new Map();
      const sizeGroupObj: Map<string, any> = new Map();
      const widthGroupObj: Map<string, any> = new Map();
      productData?.results?.forEach((elem: any) => {
        const sizeName = getFilteredAttribute('variantSelectorValue2', elem?.masterVariant);
        const widthName = getFilteredAttribute('variantSelectorValue3', elem?.masterVariant);
        const dimensionSequenceStr = getFilteredAttribute('dimensionSequence', elem?.masterVariant);
        const dimensionSequence = parseFloat(dimensionSequenceStr) ?? 9999999999;

        if (dimensionSequenceStr?.length === 10 && !isNaN(dimensionSequence)) {
          const sizeSequence = parseFloat(dimensionSequenceStr.slice(0, 5));
          const widthSequence = parseFloat(dimensionSequenceStr.slice(5, 10));

          if (sizeName && !sizeGroupObj?.has(sizeName) && sizeName !== '') {
            sizeGroupObj?.set(sizeName, sizeSequence);
          }
          if (widthName && !widthGroupObj?.has(widthName) && widthName !== '') {
            widthGroupObj?.set(widthName, widthSequence);
          }
        } else {
          if (sizeName && !sizeGroupObj?.has(sizeName) && sizeName !== '') {
            sizeGroupObj?.set(sizeName, dimensionSequence);
          }
          if (widthName && !widthGroupObj?.has(widthName) && widthName !== '') {
            widthGroupObj?.set(widthName, dimensionSequence);
          }
        }

        elem?.variants?.forEach((subElem: any) => {
          const sizeName = getFilteredAttribute('variantSelectorValue2', subElem);
          const widthName = getFilteredAttribute('variantSelectorValue3', subElem);
          const dimensionSequenceStr = getFilteredAttribute('dimensionSequence', subElem);
          const dimensionSequence = parseFloat(dimensionSequenceStr) ?? 9999999999;

          if (dimensionSequenceStr?.length === 10 && !isNaN(dimensionSequence)) {
            const sizeSequence = parseFloat(dimensionSequenceStr.slice(0, 5));
            const widthSequence = parseFloat(dimensionSequenceStr.slice(5, 10));

            if (sizeName && !sizeGroupObj?.has(sizeName) && sizeName !== '') {
              sizeGroupObj?.set(sizeName, sizeSequence);
            }
            if (widthName && !widthGroupObj?.has(widthName) && widthName !== '') {
              widthGroupObj?.set(widthName, widthSequence);
            }
          } else {
            if (sizeName && !sizeGroupObj?.has(sizeName) && sizeName !== '') {
              sizeGroupObj?.set(sizeName, dimensionSequence);
            }
            if (widthName && !widthGroupObj?.has(widthName) && widthName !== '') {
              widthGroupObj?.set(widthName, dimensionSequence);
            }
          }
        });
      });
      const sizeMapArray = Array.from(sizeGroupObj);
      const widthMapArray = Array.from(widthGroupObj);

      const sortedSizeGroupArray = sizeMapArray.toSorted((a, b) => a[1] - b[1]);
      const sortedWidthGroupArray = widthMapArray.toSorted((a, b) => a[1] - b[1]);

      sortedSizeGroupArray.forEach(([size]) => {
        sizeGroup.set(size, true);
      });

      sortedWidthGroupArray.forEach(([size]) => {
        widthGroup.set(size, true);
      });

      if (widthGroup.size === 1) {
        setSelectedWidth(sortedWidthGroupArray[0][0]);
      }
      if (sizeGroup.size === 1) {
        setSelectedSize(sortedSizeGroupArray[0][0]);
      }
      setSizeGroup(sizeGroup);
      setWidthGroup(widthGroup);
      setGlobalSizeAndWidthGroup({
        sizeGroup: sizeGroup,
        widthGroup: widthGroup,
        selectedSize: selectedSize,
        selectedWidth: selectedWidth,
      });
    }
  }, [initialSize]);

  useEffect(() => {
    setGlobalAddToCart(() => handleAddToCart);
  }, [initialColor, initialSize]);

  useEffect(() => {
    if (selectedWarranty && lineItem?.variant?.sku === initialSize?.sku) {
      setSelectedWarrantySku(selectedWarranty?.variant?.sku as string);
    } else {
      setSelectedWarrantySku('');
    }
  }, [initialSize]);

  useEffect(() => {
    if (sizeGroup && sizeGroup?.size && (selectedSize || selectedWidth)) {
      const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
      if (selectedSize) {
        const widthVariant: Variant[] = getVariantsForAttributeValue(
          allVariants,
          'variantSelectorValue2',
          selectedSize,
        );
        if (widthVariant?.length > 0) {
          if (!selectedWidth || widthVariant?.length === 1) {
            setInitialSize(widthVariant[0]);
          } else {
            widthVariant?.forEach((widthVariantItem: Variant) => {
              const widthName = getFilteredAttribute('variantSelectorValue3', widthVariantItem);
              if (widthName === selectedWidth) {
                setInitialSize(widthVariantItem);
              }
            });
          }
        } else {
          const filteredVariants = allVariants?.filter((variant) =>
            variant?.attributesRaw?.some(
              (attr: any) => attr?.name === 'variantSelectorValue2' && attr?.value === selectedSize,
            ),
          );
          setInitialSize(filteredVariants[0]);
        }
      }

      if (selectedWidth) {
        const sizeVariant: Variant[] = getVariantsForAttributeValue(
          allVariants,
          'variantSelectorValue3',
          selectedWidth,
        );
        if (sizeVariant?.length > 0) {
          if (!selectedSize || sizeVariant?.length === 0) {
            setInitialSize(sizeVariant[0]);
          } else {
            sizeVariant?.forEach((sizeVariantItem: Variant) => {
              const sieName = getFilteredAttribute('variantSelectorValue2', sizeVariantItem);
              if (sieName === selectedSize) {
                setInitialSize(sizeVariantItem);
              }
            });
          }
        }
      }
    }
    setGlobalSizeAndWidthGroup({
      sizeGroup: sizeGroup,
      widthGroup: widthGroup,
      selectedSize: selectedSize,
      selectedWidth: selectedWidth,
    });
  }, [selectedSize, selectedWidth]);

  const handleColorClick = (key: string) => {
    productData?.results?.map((item: any) => {
      if (item.key === key) {
        setInitialColor(item);
      }
    });
  };
  const clearMiniCartMsgs = () => {
    setErrorMsg('');
    setSuccessMsg('');
  };

  const isDisabled = (size: any) => {
    return (
      !size?.availability?.noChannel ||
      !size?.availability?.noChannel?.isOnStock ||
      (!size?.availability?.noChannel?.isOnStock && size?.availability?.noChannel?.restockableInDays)
    );
  };

  useEffect(() => {
    if (cartData?.lineItems) {
      const foundLineItem = cartData.lineItems.find((lineItem) => lineItem?.lineItemId == URLLineItemId);
      setLineItem(foundLineItem);
    }
  }, [cartData, URLLineItemId]);

  useEffect(() => {
    if (lineItem && cartData?.lineItems) {
      const foundWarranty = cartData.lineItems.find((cartItem) => cartItem?.lineGroupId == lineItem?.lineItemId);
      setSelectedWarranty(foundWarranty);
    }
  }, [lineItem, cartData]);

  const handleEditCart = async (id: string, count: number, variant: Variant) => {
    if ((sizeGroup?.size && !selectedSize) || (widthGroup?.size && !selectedWidth)) {
      setError(true);
      if (!selectedSize) {
        setSizeErrorMessage(mapLocaleToMeaningfulFormat().requiredSize);
        focusOnErrorMsgContent('size');
      }
      if (!selectedWidth) {
        setWidthErrorMessage(mapLocaleToMeaningfulFormat().requiredWidth);
        if (selectedSize) {
          focusOnErrorMsgContent('width');
        }
      }
      return;
    }
    setError(false);
    if (isUpdateCartDisabled(initialSize) && cartData?.orderType != ORDER_TYPES.MAIL_ORDER) {
      toggle?.();
      return;
    }
    try {
      setItemUpdated(true);
      const quantityToAdd = count;
      const availableQuantity = initialSize?.availability?.noChannel?.availableQuantity;
      const backOrderValue = initialSize?.backOrderValue;
      const maxAvailableQuantity = availableQuantity + backOrderValue;
      if (quantityToAdd > maxAvailableQuantity && cartData?.orderType != ORDER_TYPES.MAIL_ORDER) {
        toggle?.();
      } else {
        if (
          lineItem?.variant?.sku === variant?.sku &&
          ((!selectedWarranty && !selectedWarrantySku) || selectedWarrantySku === selectedWarranty?.variant?.sku)
        ) {
          let warrantyOptions: WarrantyOptions = {};
          if (selectedWarranty) {
            warrantyOptions = {
              lineItemId: selectedWarranty?.lineItemId,
              count: quantityToAdd,
            };
          }
          if (quantityToAdd < 1) {
            await removeItem(lineItem.lineItemId as string);
            localStorage.setItem(
              RECENTLY_REMOVED,
              JSON.stringify({
                sku: lineItem?.variant?.sku,
                count: quantityToAdd,
                name: lineItem?.name,
                warrantyOptions: warrantyOptions,
              }),
            );
            setEditNotificationMessage(
              `<a href="${lineItem?._url || '#'}" class="underline">${lineItem?.name}</a> ${
                mapLocaleToMeaningfulFormat([`${getSelectedDivision()}Site`]).successfullyRemovedFromCart
              }`,
            );
            setShowUndoButton?.(true);
            setIsError(false);
          } else {
            await updateItem(
              lineItem.lineItemId as string,
              quantityToAdd,
              lineItem?.count ?? 1,
              selectedWarranty ? warrantyOptions : undefined,
            );
            router.push('/cart');
            setEditNotificationMessage('');
            setShowUndoButton?.(false);
            setIsError(true);
          }
          toggle?.();
        } else {
          const siteId = getCookie(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
          const warrantyOptions =
            selectedWarrantySku && (selectedWarranty || lineItem)
              ? {
                  isWarrantySelected: !!selectedWarrantySku,
                  sku: selectedWarrantySku,
                  id: selectedWarranty?.lineItemId,
                }
              : undefined;
          await replaceCartLineItem(id, quantityToAdd, variant, warrantyOptions, undefined, siteId);
          router.push('/cart');
          if (selectedWarranty && !selectedWarrantySku) {
            await removeItem(selectedWarranty?.lineItemId as string);
          }
        }
      }
    } catch (error) {
      console.error('An error occurred while editing the cart');
    }
  };

  const isUpdateCartDisabled = (size: any) => {
    const availableQty = backOrderedValue + size?.availability?.noChannel?.availableQuantity;
    return (
      (lineItem?.count === qty &&
        lineItem?.variant?.sku === size?.sku &&
        selectedWarrantySku === selectedWarranty?.variant?.sku) ||
      qty > availableQty ||
      availableQty <= 0
    );
  };

  const focusOnErrorMsgContent = (attribute: string) => {
    const className = attribute === 'size' ? 'size-error' : 'width-error';
    const divRef = document?.getElementsByClassName(className)?.[0] as HTMLElement;
    if (divRef) {
      divRef.setAttribute('tabindex', '-1');
      divRef.focus();
    }
  };
  const handleAddToCart = async (
    variant: any,
    quantity = 1,
    isSpecialProduct = false,
    personalizeOptions?: any,
    warrantyOptions?: WarrantyOptions,
    notesPayload?: any,
  ) => {
    const upSell = query.get('upSell') === 'true' ? true : false;
    const crossSell = query.get('crossSell') === 'true' ? true : false;

    let maxOrderQuantityFlag = false;
    const maxOrderQuantity = projectSettings?.maxOrderQuantity ?? 30;
    const itemIndexFound = cartData?.lineItems?.findIndex(
      (currentLineItem) => currentLineItem?.variant?.sku === variant?.sku,
    );
    if (cartData?.lineItems && cartData?.lineItems?.length >= maxOrderQuantity) {
      maxOrderQuantityFlag = (itemIndexFound !== -1 && isSpecialProduct) || itemIndexFound === -1;
    }

    if ((sizeGroup?.size && !selectedSize) || (widthGroup?.size && !selectedWidth)) {
      setError(true);
      if (!selectedSize) {
        setSizeErrorMessage(mapLocaleToMeaningfulFormat().requiredSize);
        focusOnErrorMsgContent('size');
      }
      if (!selectedWidth) {
        setWidthErrorMessage(mapLocaleToMeaningfulFormat().requiredWidth);
        if (selectedSize) {
          focusOnErrorMsgContent('width');
        }
      }
      return;
    }
    if (maxOrderQuantityFlag) {
      setSuccessMsg('');
      setErrorMsg(
        mapLocaleToMeaningfulFormat([variant?.abwStyle ?? '', projectSettings?.customerCareNumber ?? ''])
          .maxOrderQuantityError,
      );
      setDrawerVisible(true);
      setAddToCartLoading(false);
      setTimeout(() => {
        clearMiniCartMsgs();
      }, 3000);
      return;
    }
    setAddToCartLoading(true);
    await addItem(
      variant,
      quantity,
      isSpecialProduct,
      personalizeOptions,
      warrantyOptions,
      crossSell,
      upSell,
      notesPayload,
    )
      .then(() => {
        setErrorMsg('');
        setSuccessMsg(
          quantity +
            ' ' +
            (quantity > 1 ? mapLocaleToMeaningfulFormat().itemsAdded : mapLocaleToMeaningfulFormat().itemAdded),
        );
        setSelectedWarrantySku('');
        setDrawerVisible(true);
        setAddToCartLoading(false);
        router.push('/cart');
        setTimeout(() => {
          clearMiniCartMsgs();
        }, 3000);
      })
      .catch(() => {
        setSuccessMsg('');
        setErrorMsg(mapLocaleToMeaningfulFormat().unknownError);
        setDrawerVisible(true);
        setAddToCartLoading(false);
        setTimeout(() => {
          clearMiniCartMsgs();
        }, 3000);
      });
  };
  const openPersonalizationUI = () => {
    if (isDisabled(initialSize)) {
      return;
    }
    if ((sizeGroup?.size && !selectedSize) || (widthGroup?.size && !selectedWidth)) {
      setError(true);
      if (!selectedSize) {
        setSizeErrorMessage(mapLocaleToMeaningfulFormat().requiredSize);
        focusOnErrorMsgContent('size');
      }
      if (!selectedWidth) {
        setWidthErrorMessage(mapLocaleToMeaningfulFormat().requiredWidth);
        if (selectedSize) {
          focusOnErrorMsgContent('width');
        }
      }
    } else {
      handlePersonalizeDiv();
    }
  };

  useEffect(() => {
    setGlobalPersonalize(() => openPersonalizationUI);
  }, [initialColor, initialSize, selectedSize, selectedWidth, qty]);

  const showArtifiError = () => {
    const personalizeDivError = document.getElementById('artifiPersonalizationError');
    setRetryCount(0);
    if (personalizeDivError) {
      personalizeDivError.style.height = (personalizeDivError?.classList?.contains('mobile-mode') ? 700 : 600) + 'px';
      personalizeDivError.style.left = '0';
      personalizeDivError.classList.add('na');
      personalizeDivError.scrollIntoView();
    }
  };
  const closePersonalizationUI = (isError = false) => {
    if (isEditCart && !isError) {
      window.location.href = routerUrl.cart;
    } else {
      const personalizeDiv = document.getElementById('artifiPersonalization');
      if (personalizeDiv) {
        personalizeDiv.innerHTML = '';
        personalizeDiv.style.left = '';
        personalizeDiv.classList.remove('in');
      }
      if (isError) {
        showArtifiError();
      }
    }
  };
  useEffect(() => {
    if (
      !artifiLoaded &&
      initialSize?.key &&
      projectSettings?.artifiEnabled &&
      getFilteredAttribute('personalizeOption', initialColor?.masterVariant) === true &&
      webAccountId
    ) {
      const existingScript = document.getElementById('artifiScript');
      if (existingScript) {
        existingScript.remove();
      }
      const artifiScriptTag = document?.createElement('script');
      artifiScriptTag.src = projectSettings?.artifiIntegrationJSUrl;
      artifiScriptTag.defer = true;
      artifiScriptTag.id = 'artifiScript';
      artifiScriptTag.onload = () => {
        setArtifiLoaded(true);
      };
      document?.head?.appendChild(artifiScriptTag);
    }
  }, [initialSize, projectSettings, webAccountId]);

  const initializeArtifi = () => {
    const personalizeDiv = document.getElementById('artifiPersonalization');
    const userId = personalizeUserId
      ? personalizeUserId
      : webAccountId
      ? webAccountId
      : projectSettings?.artifiProfileId;
    if (initialDesignId) {
      window?.Artifi?.Initialize({
        productCode: initialColor?.key,
        websiteId: projectSettings?.artifiWebsiteId,
        designId: initialDesignId,
        userId: userId,
        divId: 'artifiPersonalization',
        isGuest: !loggedIn,
        webApiclientKey: projectSettings?.artifiWebApiClientKey,
        width: '100%',
        height: personalizeDiv?.classList?.contains('mobile-mode') ? 700 : 600,
      });
    } else {
      window?.Artifi?.Initialize({
        productCode: initialColor?.key,
        websiteId: projectSettings?.artifiWebsiteId,
        userId: userId,
        divId: 'artifiPersonalization',
        isGuest: !loggedIn,
        webApiclientKey: projectSettings?.artifiWebApiClientKey,
        width: '100%',
        height: personalizeDiv?.classList?.contains('mobile-mode') ? 700 : 600,
      });
    }
    if (personalizeDiv) {
      personalizeDiv.style.height = (personalizeDiv?.classList?.contains('mobile-mode') ? 700 : 600) + 'px';
    }

    window.removeEventListener('message', customReceiveArtifiMessage);
    window.addEventListener('message', customReceiveArtifiMessage, false);
  };

  const handlePersonalizeDiv = () => {
    const personalizeDiv = document.getElementById('artifiPersonalization');
    if (personalizeDiv && artifiLoaded) {
      personalizeDiv.innerHTML = '';
      initializeArtifi();
      personalizeDiv.style.left = '0';
      personalizeDiv.classList.add('in');
      personalizeDiv.scrollIntoView();
      setIsProcessing(false);
    } else if (!artifiLoaded && retryCount <= maxRetries) {
      setRetryCount((prevCount) => prevCount + 1);
    }
  };

  useEffect(() => {
    if (retryCount > 0 && retryCount <= maxRetries) {
      const timeout = setTimeout(() => handlePersonalizeDiv(), 1000);
      return () => clearTimeout(timeout);
    }
    if (retryCount > maxRetries) {
      showArtifiError();
      setIsProcessing(false);
    }
  }, [retryCount]);

  const customReceiveArtifiMessage = useCallback(
    (event: MessageEvent) => {
      receiveArtifiMessage(event, initialSize, selectedSize ?? '', selectedWidth ?? '', qty, selectedWarrantySku);
    },
    [selectedSize, selectedWidth, initialSize, qty, selectedWarrantySku],
  );

  useEffect(() => {
    return () => {
      window.removeEventListener('message', customReceiveArtifiMessage);
    };
  }, [customReceiveArtifiMessage]);
  useEffect(() => {
    return () => {
      sessionStorage.removeItem('personalizedItem');
    };
  }, []);

  const getPersonalizedTextFromCustomizedData = (customizedJsonData: any) => {
    let personalizetext = '';
    const result: string[] = [];
    const extractTextValues = (items?: any[]): void => {
      items?.forEach((item) => {
        if (item?.text) {
          result.push(item?.text);
        }
      });
    };
    const extractSideValues = (side: any): void => {
      side?.text && extractTextValues(side?.text);
      side?.circletext && extractTextValues(side?.circletext);
    };
    customizedJsonData?.Front && extractSideValues(customizedJsonData?.Front);
    customizedJsonData?.Back && extractSideValues(customizedJsonData?.Back);
    customizedJsonData?.FRONT && extractSideValues(customizedJsonData?.FRONT);
    customizedJsonData?.BACK && extractSideValues(customizedJsonData?.BACK);
    personalizetext = result.join(', ');
    return personalizetext;
  };

  const handleEditPersonalizedItem = async (
    lineItemId: string,
    qty: number,
    oldQty: number,
    personalizeOptions: PersonalizeOptions,
  ) => {
    setIsProcessing(true);
    try {
      await updateItem(lineItemId, qty, oldQty, undefined, personalizeOptions);
      if (isEditCart && initialDesignId) {
        window.location.href = routerUrl.cart;
      }
    } catch (error) {
      console.error('An error occurred while editing the cart');
      setIsProcessing(false);
    }
  };

  const receiveArtifiMessage = (
    event: any,
    initialSize: any,
    selectedSize: string,
    selectedWidth: string,
    qty: any,
    selectedWarrantySku: string,
  ) => {
    let origin = event.origin;
    if (origin?.indexOf('five9') > -1) {
      return;
    }
    let eventObj;
    if (origin?.indexOf('designer.artifi.net') > -1) {
      try {
        eventObj = JSON.parse(event?.data);
      } catch (error) {
        console.error('Error while parsing event object', error);
      }
    } else {
      try {
        const rawEventObj = JSON.parse(event?.data?.data);
        origin = rawEventObj?.origin;
        eventObj = JSON.parse(rawEventObj?.data);
      } catch (error) {
        console.error('Error while parsing event object', error);
      }
    }
    if (window?.Artifi && !window?.Artifi.isValidArtifiDomain(origin)) {
      return;
    }
    const action = eventObj?.action;
    switch (action) {
      case window?.Artifi?.Constant?.addToCart: {
        if (validateArtifiResponse(eventObj?.data)) {
          const personalizedItemStr = sessionStorage.getItem('personalizedItem');
          const personalizedItem = personalizedItemStr ? JSON.parse(personalizedItemStr) : null;

          const personalizeOptions: PersonalizeOptions = {
            personalizeProductId: JSON.stringify(eventObj?.data?.custmizeProductId),
            personalizeText: getPersonalizedTextFromCustomizedData(eventObj?.data?.customizedData),
            personalizeUserId: eventObj?.data?.userId,
          };
          const abwStyle = getAttribute('abwStyle', initialSize);
          if (sizeGroup?.size && selectedSize) {
            setSelectedSize(selectedSize);
          }
          if (widthGroup?.size && selectedWidth) {
            setSelectedWidth(selectedWidth);
          }
          if (qty) {
            setQty(qty);
          }
          let warrantyOptions: { isWarrantySelected: boolean; sku: string } | undefined = undefined;
          if (selectedWarrantySku) {
            warrantyOptions = {
              isWarrantySelected: !!selectedWarrantySku,
              sku: selectedWarrantySku,
            };
          }

          const addToCartAndRemoveFromWishlist = async () => {
            try {
              if (isEditCart) {
                handleEditPersonalizedItem(
                  lineItem?.lineItemId as string,
                  lineItem?.count ?? 1,
                  lineItem?.count ?? 1,
                  personalizeOptions,
                );
              } else {
                handleAddToCart(
                  { sku: initialSize.key, abwStyle: abwStyle },
                  qty,
                  true,
                  personalizeOptions,
                  warrantyOptions,
                );
              }
              if (personalizedItem) {
                sessionStorage.removeItem('personalizedItem');
              }
            } catch (error) {}
          };

          addToCartAndRemoveFromWishlist();
        } else {
        }
        break;
      }
      case 'close-pop-up': {
        closePersonalizationUI();
        sessionStorage.removeItem('personalizedItem');
        break;
      }
      case 'error': {
        closePersonalizationUI(true);
        sessionStorage.removeItem('personalizedItem');
        break;
      }
      default: {
        break;
      }
    }
  };

  const validateArtifiResponse = (data: any) => {
    if (typeof data == 'undefined' || data == '') {
      closePersonalizationUI(true);
      return false;
    } else {
      const custmizeProductId = data?.custmizeProductId ?? '';
      const customizeText = JSON.stringify(data?.customizedData) ?? '';
      const userId = data?.userId ?? '';
      if (custmizeProductId == '' || customizeText == '' || userId == '') {
        closePersonalizationUI(true);
        return false;
      }
    }
    return true;
  };
  useEffect(() => {
    if (
      !artifiLoaded &&
      initialSize?.key &&
      projectSettings?.artifiEnabled &&
      getFilteredAttribute('personalizeOption', initialColor?.masterVariant) === true &&
      webAccountId
    ) {
      const existingScript = document.getElementById('artifiScript');
      if (existingScript) {
        existingScript.remove();
      }
      const artifiScriptTag = document?.createElement('script');
      artifiScriptTag.src = projectSettings?.artifiIntegrationJSUrl;
      artifiScriptTag.defer = true;
      artifiScriptTag.id = 'artifiScript';
      artifiScriptTag.onload = () => {
        setArtifiLoaded(true);
      };
      document?.head?.appendChild(artifiScriptTag);
    }
  }, [initialSize, projectSettings, webAccountId]);

  const [availableMessageSku, setAvailableMessageSku] = useState('');
  const [selectedVariantAvailableMessage, setSelectedVariantAvailableMessage] = useState('');
  const [variantAvailablityClassName, setVariantAvailablityClassName] = useState('');

  useEffect(() => {
    const fetchAvailability = async (sku: string) => {
      if (checkIsAvailMsgReq()) {
        try {
          const result: any = await getAvailability({ sku: sku, count: qty });
          if (result) {
            setAvailableMessageSku(result?.sku);
            setSelectedVariantAvailableMessage(result?.message);
            setBackOrderedValue(result?.backOrderValue);
            setStockValue(result?.stockValue);
            let intervalDays = 0;
            if (result?.backOrderDateWithYear && isFutureDate(result?.backOrderDateWithYear)) {
              intervalDays = daysBetweenCurrentAndDate(result?.backOrderDateWithYear);
            }
            const { arrivalDate, backorderDate } = getArrivalAndBackorderDateFromResponse(
              initialArrivalDate,
              getDropShipValue(initialSize),
              isPersonalized(),
              projectSettings,
              false,
              intervalDays,
            );
            if (result?.value === 'backOrdered') {
              setArrivalDate(result?.stockValue > 0 ? arrivalDate : backorderDate);
              setIsInStockWithBackOrder(result?.stockValue > 0);
              setBackOrderedArrivalDate(backorderDate);
            } else if (initialArrivalDate) {
              setArrivalDate(arrivalDate);
              setIsInStockWithBackOrder(false);
              setBackOrderedArrivalDate('');
            }
            const className = valueToClassName[result?.value] || 'text-[#DF2429]';
            setVariantAvailablityClassName(className);
          } else {
            setSelectedVariantAvailableMessage(mapLocaleToMeaningfulFormat().outOfStock);
            setVariantAvailablityClassName(mapLocaleToMeaningfulFormat().outOfStockClass);
          }
        } catch (error) {
          setSelectedVariantAvailableMessage(mapLocaleToMeaningfulFormat().outOfStock);
          setVariantAvailablityClassName(mapLocaleToMeaningfulFormat().outOfStockClass);
          console.error('Error fetching availability:', error);
        }
        setIsAvailableMsgDisplay(true);
      } else {
        if (!isAvailableMsgDisplay) {
          setSelectedVariantAvailableMessage('');
        }
      }
    };
    const totalAvailableQuantity =
      initialSize?.availability?.noChannel?.availableQuantity + initialSize?.backOrderValue;
    if (
      initialSize?.sku &&
      (totalAvailableQuantity === 0 || qty <= totalAvailableQuantity || (selectedSize && selectedWidth))
    ) {
      fetchAvailability(initialSize.sku);
    }
  }, [initialSize, qty, selectedSize, selectedWidth, initialArrivalDate]);

  useEffect(() => {
    if (initialSize?.key && availableMessageSku && initialSize?.key === availableMessageSku) {
      setAvailabilityMessage(selectedVariantAvailableMessage);
      setAvailabilityClassName(variantAvailablityClassName);
    }
  }, [selectedVariantAvailableMessage, selectedSize, selectedWidth, availableMessageSku, initialSize]);

  const getColorName = (item: any) => {
    const colourName = getFilteredAttribute('variantSelectorValue1', item?.masterVariant);
    return colourName;
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedVariant, setSelectedVariant] = useState<any>({});
  useEffect(() => {
    if (isEditCart && productData?.results?.length > 0) {
      const lineItemId = params?.get('lineItemId');
      const lineItem = cartData?.lineItems?.find((lineItem) => lineItem?.lineItemId === lineItemId);
      setSelectedVariant(lineItem);
      const variantKey = lineItem?.variant?.sku;
      const productKey = lineItem?.productKey;
      const product = productData?.results?.find((product: any) => product?.key === productKey);
      const masterVariant = product?.masterVariant;
      const subVariants = product?.variants;
      const allVariants = [masterVariant, ...subVariants];
      const variant = allVariants?.find((product: any) => product?.key === variantKey);
      const size = getAttribute('variantSelectorValue2', variant);
      const width = getAttribute('variantSelectorValue3', variant);
      handleColorClick(variant?.key);
      setQty(lineItem?.count ?? 1);
      setInitialSize(variant);
      setSelectedSize(size);
      setSelectedWidth(width);
    }
  }, [productData]);

  const getDropShipValue = (initialSize: any) => {
    let isDropShip = false;
    if (
      initialSize?.attributesRaw?.some(
        (item: any) => item.name === mapLocaleToMeaningfulFormat().dropShipEligible && item.value,
      )
    ) {
      isDropShip = true;
    }
    return isDropShip;
  };

  const isPersonalized = () => {
    let isPersonalized = false;
    if (getFilteredAttribute('personalizeOption', initialColor?.masterVariant)) {
      isPersonalized = true;
    }
    return isPersonalized;
  };

  useEffect(() => {
    if (
      initialColor &&
      (initialColorLoaded || lineItem?.variant || (initialSize && initialSize?.key === '')) &&
      !isDeliveryCodeUpdated
    ) {
      if (!filtersAttrSelected && (!initialSize || initialSize?.key === '')) {
        initialColorLoaded = true;
        setInitialSize(initialColor.masterVariant);
      } else {
        initialColorLoaded = false;
      }
      const matchingVariant = initialColor?.variants?.find((variant: any) => variant?.sku === lineItem?.variant?.sku);
      if (isEditCart) {
        if (matchingVariant) {
          setSelectedSize(getFilteredAttribute('variantSelectorValue2', matchingVariant));
          setSelectedWidth(getFilteredAttribute('variantSelectorValue3', matchingVariant));
        } else if (initialColor?.masterVariant?.sku === lineItem?.variant?.sku) {
          setSelectedSize(getFilteredAttribute('variantSelectorValue2', initialColor?.masterVariant));
          setSelectedWidth(getFilteredAttribute('variantSelectorValue3', initialColor?.masterVariant));
        } else {
          setSelectedSize('');
          setSelectedWidth('');
        }
      }
      setMoreVariants(initialColor?.variants?.length !== 0);
      if (!isEditCart && !filtersAttrSelected && initialSize && (!sizeGroup || sizeGroup?.size !== 1)) {
        setSelectedSize('');
        if (widthGroup?.size !== 1) {
          setSelectedWidth('');
        }
      }
    }
    const masterAvailMsg: string = initialColor?.masterVariant?.availabiliityMsg;
    const variantAvailabilityList: string[] = initialColor?.variants.map(
      (variantItem: Variant) => variantItem?.availabiliityMsg,
    );
    if (masterAvailMsg && variantAvailabilityList?.every((item) => item === masterAvailMsg)) {
      setAvailabilityMessage(masterAvailMsg);
      const className = valueToClassName[initialColor?.masterVariant?.availabiliityMsgVal] || 'text-[#DF2429]';
      setAvailabilityClassName(className);
      setIsAvailableMsgDisplay(true);
    } else {
      setAvailabilityMessage('');

      setIsAvailableMsgDisplay(false);
    }
    const hasInvenotry = initialColor?.activeFilters?.hasInvenotry ?? false;
    if (!hasInvenotry) {
      const colourName = getFilteredAttribute('variantSelectorValue1', initialColor?.masterVariant);
      setError(true);
      setNotificationMessage(mapLocaleToMeaningfulFormat([`${colourName}`]).colorProductOutofStock);
      setSeeSimilarItems(false);
    } else {
      setError(false);
      setNotificationMessage('');
    }
  }, [initialColor, lineItem]);

  useEffect(() => {
    if (
      initialColor &&
      (!selectedSize || !selectedWidth) &&
      sessionStorage?.getItem('filtersSelected') &&
      (sizeGroup || widthGroup) &&
      !isEditCart
    ) {
      const filtersSelected = JSON.parse(sessionStorage?.getItem('filtersSelected') || '[]');
      if (showPDPBottomBox) {
        sessionStorage.removeItem('filtersSelected');
      }
      let selectedSizeValue = '';
      const findMatch = (group: Map<string, boolean>, objValue: string, type: string) => {
        const objValueLower = objValue?.trim()?.replace(/\s/g, '')?.toLowerCase();
        const exactMatch = Array.from(group?.entries())?.find(([key]) => objValueLower === key?.toLowerCase());
        if (exactMatch) {
          return exactMatch;
        } else {
          if ('width' === type) {
            const result = Array.from(group.entries()).find(([key]) => {
              if (isWidthAvailable(key)) {
                const normalizedParts = key
                  ?.trim()
                  ?.replace(/\s{2,}/g, ' ')
                  ?.split(' ');
                if (!normalizedParts) return false;
                const firstPart = normalizedParts[0].toLowerCase();
                const secondPart = normalizedParts.slice(1).join('').toLowerCase();
                const words = [firstPart, secondPart].filter(Boolean);
                return words.some((word) => word.indexOf(objValueLower) === 0);
              }
            });
            return result;
          } else {
            return Array.from(group?.entries())?.find(([key]) => key?.toLowerCase()?.indexOf(objValueLower) === 0);
          }
        }
      };

      filtersSelected.forEach((obj: any) => {
        if (obj?.name?.indexOf('Size') > -1 && sizeGroup?.size) {
          const matchedSize = findMatch(sizeGroup, obj?.value, 'size');
          if (matchedSize) {
            const [sizeKey] = matchedSize;
            filtersAttrSelected = true;
            selectedSizeValue = sizeKey;
            if (isSizeAvailable(sizeKey)) {
              setSelectedSize(sizeKey);
              setVariantAvailability(sizeKey, '');
            }
          }
        }
      });
      filtersSelected.forEach((obj: any) => {
        if (obj?.name?.indexOf('Width') > -1 && widthGroup?.size) {
          const matchedWidth = findMatch(widthGroup, obj?.value, 'width');
          if (matchedWidth) {
            const [widthKey] = matchedWidth;
            filtersAttrSelected = true;
            if (isWidthAvailable(widthKey)) {
              if (selectedSizeValue) {
                if (getVariantAvailability(selectedSizeValue, widthKey)) {
                  setSelectedWidth(widthKey);
                }
              } else {
                setSelectedWidth(widthKey);
              }
              setVariantAvailability('', widthKey);
            }
          }
        }
      });
    }
  }, [sizeGroup, widthGroup, initialColor]);

  const getVariantAvailability = (size: string, width: string) => {
    let isVariantAvailable = false;
    const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
    if (size) {
      const widthVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue2', size);
      if (widthVariant) {
        widthVariant?.forEach((widthVariantItem: Variant) => {
          const widthName = getFilteredAttribute('variantSelectorValue3', widthVariantItem);
          if (widthGroup?.has(widthName) && widthName === width) {
            isVariantAvailable =
              widthVariantItem?.availability?.noChannel?.isOnStock || widthVariantItem?.backOrder || false;
          }
        });
      }
    }
    if (width) {
      const sizeVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue3', width);
      if (sizeVariant) {
        sizeVariant?.forEach((sizeVariantItem: Variant) => {
          const sizeName = getFilteredAttribute('variantSelectorValue2', sizeVariantItem);
          if (sizeGroup?.has(sizeName) && sizeName === size) {
            isVariantAvailable =
              sizeVariantItem?.availability?.noChannel?.isOnStock || sizeVariantItem?.backOrder || false;
          }
        });
      }
    }
    return isVariantAvailable;
  };

  const setVariantAvailability = (size: string, width: string) => {
    const allVariants: Variant[] = [initialColor?.masterVariant, ...(initialColor?.variants || [])].filter(Boolean);
    if (size) {
      const widthVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue2', size);
      if (widthVariant) {
        widthVariant?.forEach((widthVariantItem: Variant) => {
          const widthName = getFilteredAttribute('variantSelectorValue3', widthVariantItem);
          if (widthGroup?.has(widthName)) {
            widthGroup?.set(
              widthName,
              widthVariantItem?.availability?.noChannel?.isOnStock ||
                widthVariantItem?.backOrder ||
                cartData?.orderType == ORDER_TYPES.MAIL_ORDER ||
                false,
            );
          }
        });
      }
    }

    if (width) {
      const sizeVariant: Variant[] = getVariantsForAttributeValue(allVariants, 'variantSelectorValue3', width);
      if (sizeVariant) {
        sizeVariant?.forEach((sizeVariantItem: Variant) => {
          const sizeName = getFilteredAttribute('variantSelectorValue2', sizeVariantItem);
          if (sizeGroup?.has(sizeName)) {
            sizeGroup.set(
              sizeName,
              sizeVariantItem?.availability?.noChannel?.isOnStock ||
                sizeVariantItem?.backOrder ||
                cartData?.orderType == ORDER_TYPES.MAIL_ORDER ||
                false,
            );
          }
        });
      }
    }
  };

  const disableButton = () => {
    return (
      availabilityMessage === mapLocaleToMeaningfulFormat().outOfStock && cartData?.orderType != ORDER_TYPES.MAIL_ORDER
    );
  };

  const getAddToCartButton = () => {
    return (
      <>
        {' '}
        {!isEditCart ? (
          <Button
            disabled={disableButton()}
            onClick={async () => {
              if (isMailOrderProduct) {
                if (mailOrderNote.length === 0) {
                  setNotesError('Please enter a note.');
                  return;
                } else {
                  setNotesError('');
                }
              }

              const abwStyle = getAttribute('abwStyle', initialSize);
              const warrantyOptions: WarrantyOptions = {
                isWarrantySelected: Boolean(selectedWarrantySku),
                sku: selectedWarrantySku,
              };
              await handleAddToCart(
                { sku: isMailOrderProduct ? '999999' : initialSize.key, abwStyle: abwStyle },
                qty,
                false,
                null,
                warrantyOptions,
                notesPayload,
              );
            }}
            type="submit"
            className={`${
              showPDPBottomBox ? 'mt-6' : 'mt-0'
            } w-full gap-2 bg-[#002C4E] px-4 py-7 text-xl font-bold leading-7 text-white`}
          >
            {addToCartLoading ? (
              mapLocaleToMeaningfulFormat().adding
            ) : (
              <>
                <ShoppingBag className="hover:bg-hoverSecondaryButton h-8 w-8" />{' '}
                {mapLocaleToMeaningfulFormat().addToCart}{' '}
              </>
            )}
          </Button>
        ) : (
          <Button
            disabled={disableButton()}
            onClick={async () => {
              setAddToCartLoading(true);

              await handleEditCart(lineItem?.lineItemId ?? '', qty, initialSize).then((response: any) => {
                if (response?.cartId) {
                  router.push('/cart');
                } else {
                  setAddToCartLoading(false);
                }
              });
            }}
            type="submit"
            className={`${
              showPDPBottomBox ? 'mt-6' : 'mt-0'
            } w-full gap-2 bg-[#002C4E] px-4 py-7 text-xl font-bold leading-7 text-white`}
          >
            {addToCartLoading ? (
              mapLocaleToMeaningfulFormat().updating
            ) : (
              <>
                <ShoppingBag className="hover:bg-hoverSecondaryButton h-8 w-8" />{' '}
                {mapLocaleToMeaningfulFormat().updateCart}{' '}
              </>
            )}
          </Button>
        )}
      </>
    );
  };

  if (isMailOrderProduct) {
    return (
      <>
        <RadioGroup defaultValue="comfortable">
          <div className="my-3 flex items-center space-x-2">
            <RadioGroupItem value="default" id="r1" />
            <Label htmlFor="r1">Unable to ship to PO Box</Label>
          </div>
          <div className=" flex items-center space-x-2">
            <RadioGroupItem value="comfortable" id="r2" />
            <Label htmlFor="r2">Other</Label>
          </div>
          <div className="ml-6">
            <Textarea
              placeholder="Type your message here."
              className=" gbunmask mt-2"
              maxLength={60}
              onKeyPress={combinedKeyPressHandler}
              onChange={(e) => setMailOrderNote(e.target.value)}
            />
            <p className="text-scarletRed">{notesError}</p>
          </div>
        </RadioGroup>
        {getAddToCartButton()}{' '}
      </>
    );
  }
  return (
    initialColor && (
      <section className={`${!showPDPBottomBox ? 'px-4' : 'p-0'}`}>
        <section className="flex space-x-1 pt-30 leading-5">
          <p className="font-normal">{mapLocaleToMeaningfulFormat().color}: </p>
          <strong className="font-bold">
            {initialColor
              ? getFilteredAttribute(VARIANT_SELECTOR_VALUE_1, initialColor?.masterVariant)
              : mapLocaleToMeaningfulFormat().selectColor}
          </strong>
        </section>
        <section className="flex flex-wrap items-center gap-5 pt-4">
          {productData?.results
            ?.filter(
              (item: any) =>
                item?.activeFilters?.hasInvenotry || pathname.includes(item.key) || item.key === productKeyFromQuery,
            )
            .map((item: any, index: number) => (
              <React.Fragment key={index}>
                <CustomToolTips
                  ToolTipContent={
                    <button
                      aria-label="choose color button"
                      key={index}
                      className={`relative h-9 w-9 overflow-hidden rounded-full ring-offset-2 lg:h-11 lg:w-11 ${
                        initialColor.key === item.key ? `ring-[2px] ring-[#000]` : 'ring-[1px] ring-[#B6B6B8]'
                      }
                      ${
                        !item?.activeFilters?.hasInvenotry
                          ? ' relative overflow-hidden bg-[#F0F0F0] text-foggyGray ring-scarletRed after:absolute after:left-0 after:top-[18px] after:z-10 after:block after:w-full after:-rotate-45 after:border-t after:border-scarletRed after:content-[""]'
                          : ''
                      }
                      `}
                      onClick={() => handleColorClick(item.key)}
                    >
                      <>
                        <ContentStackImage
                          src={getAttribute('swatchImageURL', item?.masterVariant)}
                          imageHeight={44}
                          imageWidth={44}
                          alt={getColorName(item)}
                          loading={'lazy'}
                        />
                      </>
                    </button>
                  }
                  ToolTipMessage={getColorName(item)}
                />
              </React.Fragment>
            ))}
        </section>
        {sizeGroup?.size && selectedSize !== 'No Size' ? (
          <>
            <section className="size-error flex w-full justify-between space-x-1 pt-30 leading-5">
              <section>
                {error && !selectedSize && (
                  <Notification
                    message={sizeErrorMessage}
                    isError={true}
                    color={'bg-[#FFEBEB]'}
                    textColor={'text-black font-medium'}
                    icon={<ErrorIcon className="h-5 w-5" />}
                    classname={sizeErrorMessage ? 'block mb-4 md:mx-4 lg:mx-0' : 'hidden'}
                    notificationMessage={sizeErrorMessage}
                    setNotificationMessage={setSizeErrorMessage}
                    closeFlag={false}
                    isScrolltoTop={false}
                  />
                )}
                <p className="inline-block text-base font-normal">{mapLocaleToMeaningfulFormat().size}: </p>{' '}
                <strong className="text-base font-bold">
                  {selectedSize ? selectedSize : mapLocaleToMeaningfulFormat().selectSize}
                </strong>
              </section>

              <SizeChart />
            </section>
            {sizeGroup?.size > 1 && (
              <section className="flex flex-wrap items-center gap-2.5 pt-4">
                {Array.from(sizeGroup?.keys())?.map((key: string, indx: number) => {
                  return (
                    <button
                      key={indx}
                      disabled={!isSizeAvailable(key)}
                      aria-label=""
                      onClick={() => {
                        setSelectedSize(key);
                        setVariantAvailability(key, '');
                      }}
                      className={`min-h-[44px] min-w-[44px] border p-2 ${
                        selectedSize === key ? 'border-2 border-[#000] font-bold' : 'border-[#B6B6B8] font-medium'
                      } text-sm leading-5 ${
                        !isSizeAvailable(key)
                          ? 'relative overflow-hidden bg-[#F0F0F0] text-[#b6b6b8] after:absolute after:left-0 after:top-[50%] after:z-10 after:block after:w-full after:-rotate-45 after:border-t after:border-foggyGray after:content-[""]'
                          : ''
                      }`}
                    >
                      {sizeButton(key, selectedSize)}
                    </button>
                  );
                })}
              </section>
            )}
          </>
        ) : (
          <></>
        )}

        {widthGroup?.size ? (
          <>
            <section className="width-error flex w-full justify-between space-x-1 pt-30 leading-5">
              <section>
                {error && !selectedWidth && (
                  <Notification
                    message={widthErrorMessage}
                    isError={true}
                    color={'bg-[#FFEBEB]'}
                    textColor={'text-black font-medium'}
                    icon={<ErrorIcon className="size-5" />}
                    classname={widthErrorMessage ? 'block mb-2 md:mx-4 lg:mx-0' : 'hidden'}
                    notificationMessage={widthErrorMessage}
                    setNotificationMessage={setWidthErrorMessage}
                    closeFlag={false}
                    isScrolltoTop={false}
                  />
                )}
                <p className="inline-block font-normal">{mapLocaleToMeaningfulFormat().width}: </p>{' '}
                <strong className="font-bold">
                  {selectedWidth ? selectedWidth : mapLocaleToMeaningfulFormat().selectWidth}
                </strong>
              </section>
            </section>
            <section className="flex flex-wrap items-center gap-2.5 pt-4">
              {Array.from(widthGroup?.keys())?.map((key: string, indx: number) => {
                return (
                  <button
                    key={indx}
                    disabled={!isWidthAvailable(key)}
                    aria-label=""
                    onClick={() => {
                      setSelectedWidth(key);
                      setVariantAvailability('', key);
                    }}
                    className={`min-h-[44px] min-w-[100px] border ${
                      selectedWidth === key ? 'border-2 border-black font-bold' : 'border-foggyGray font-medium'
                    } px-5 py-2.5 text-sm leading-5 ${
                      !isWidthAvailable(key)
                        ? 'relative min-w-[130px] overflow-hidden bg-[#F0F0F0] text-[#b6b6b8] after:absolute after:left-0 after:top-[50%] after:z-10 after:block after:w-full after:-rotate-45 after:border-t after:border-foggyGray after:content-[""]'
                        : ''
                    }`}
                  >
                    {key}
                  </button>
                );
              })}
            </section>
          </>
        ) : (
          <></>
        )}

        <section className="flex items-center gap-x-1 pt-30">
          <Price initialColor={initialColor} initialSize={initialSize} locale={locale} />
        </section>
        {initialSize?.price?.pricePerMonth && (
          <section className="flex gap-1 pt-5">
            <section>
              <p className="inline-block text-sm font-normal leading-5">{mapLocaleToMeaningfulFormat().or}</p>{' '}
              <strong className="inline-block text-lg font-bold">
                {CurrencyHelpers.formatForCurrency(initialSize?.price?.pricePerMonth, false, locale)}/
                {mapLocaleToMeaningfulFormat().month}
              </strong>{' '}
              <p className="inline-block text-sm font-normal leading-5">
                {getSelectedDivision() === 'ZD'
                  ? mapLocaleToMeaningfulFormat([getFormattedBrandSiteName(getSelectedDivision() ?? 'ZD') || ''])
                      .withBrandZD
                  : mapLocaleToMeaningfulFormat([getFormattedBrandSiteName(getSelectedDivision() ?? 'ZB') || ''])
                      .withBrandCredit}
              </p>
            </section>
            <ToolTips className="size-5 mt-1" Content={{ ContentToolTip: <PdpTooltip /> }} />
          </section>
        )}
        <section className="flex items-center pt-5">
          <section className="flex items-center gap-2">
            <p className="inline-block font-normal">Qty: </p>
            <Counter
              initialValue={isEditCart ? lineItem?.count : 1}
              onChange={setQty}
              onCartHeaderChange={setCartHeaderQty}
              isPdp={showPDPBottomBox}
              lineItemId={lineItem?.lineItemId}
              toggle={toggle}
              isEditCart={isEditCart}
              setMaxQuantityWarningMessage={setMaxQuantityWarningMessage}
              sizeGroupLength={sizeGroup?.size}
              widthGroupLength={widthGroup?.size}
              selectedSize={selectedSize}
              selectedWidth={selectedWidth}
              isAvaialbleMsgReq={checkIsAvailMsgReq()}
            />
          </section>
        </section>
        <div className="w-full">
          {maxQuantityWarningMessage && availabilityMessage !== mapLocaleToMeaningfulFormat().outOfStock && (
            <section className="mt-4 flex max-w-[356px] gap-2 bg-[#FFF4E6] py-3 pr-3 text-sm font-medium text-black">
              <WarningIcon className="size-5 ml-3" />
              {maxQuantityWarningMessage}
            </section>
          )}
        </div>
        {availabilityMessage && isAvailableMsgDisplay && (
          <AvailabilityMsgDisplay
            isInStockWithBackOrder={isInStockWithBackOrder}
            availabilityMsg={availabilityMessage}
            arrivalDate={arrivalDate}
            backOrderedArrivalDate={backOrderedArrivalDate}
            availabilityClassName={availabilityClassName}
            stockValue={stockValue}
            qty={qty}
          />
        )}
        {initialSize && getAttribute(FULFILLMENT_METHOD, initialSize) && (
          <>
            <span>{mapLocaleToMeaningfulFormat().fulfillmentMethod} </span>
            <strong>
              {getAttribute(FULFILLMENT_METHOD, initialSize) === 'External VendorNet'
                ? mapLocaleToMeaningfulFormat().fulfillmentExternal
                : getAttribute(FULFILLMENT_METHOD, initialSize)}
            </strong>
          </>
        )}
        {initialColor?.warrantyProducts &&
          (getFilteredAttribute('warrantyEligible', initialColor?.masterVariant) === '1' ||
            getFilteredAttribute('warrantyEligible', initialColor?.masterVariant) === 'true') && (
            <section className="mt-7">
              <PdpProtectionPlan
                setSelectedWarrantySku={setSelectedWarrantySku}
                selectedWarrantySku={selectedWarrantySku}
              />
            </section>
          )}
        <section>
          {getFilteredAttribute('personalizeOption', initialColor?.masterVariant) !== true ? (
            getAddToCartButton()
          ) : (
            <Button
              type="button"
              onClick={openPersonalizationUI}
              className={`${
                showPDPBottomBox ? 'mt-6' : 'mt-0'
              } w-full gap-2 bg-deepBlue px-4 py-7 text-xl font-bold leading-7 text-white`}
            >
              <ShoppingBag className="hover:bg-hoverSecondaryButton size-8" />{' '}
              {mapLocaleToMeaningfulFormat().personalize}{' '}
            </Button>
          )}
        </section>
        <ExcludedBrandsNote widgetData={widgetData} />
      </section>
    )
  );
};

export default PdpColorFilter;
